import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';

import { AuthGuard } from '@/core/auth';
import { CarePlanServiceGuard, StudyGuard } from '@/shared/guard';

import {
  CwfDocumentRoute,
  MhsDocumentRoute,
  QualityReviewDocumentRoute,
  RadiologistReportDocumentRoute,
} from '../modules/document';
import { ErrorBoundaryRoute } from '../modules/error-boundary';
import { NotFoundRoute } from '../modules/not-found';
import {
  AiFindingsRoute,
  ComparisonLayout,
  ComparisonRoute,
  FinalImpressionRoute,
  KeyImagesRoute,
  OrganRoute,
  PreviewRoute,
  QualityReviewRoute,
  ReasonForScanRoute,
  ReportingLayout,
} from '../modules/reporting';

export const ROUTES = createBrowserRouter(
  [
    {
      children: [
        {
          children: [
            {
              element: <ComparisonRoute />,
              index: true,
            },
          ],
          element: <ComparisonLayout />,
          path: 'comparisons',
        },
        {
          children: [
            {
              element: <Navigate replace to="reason-for-scan" />,
              index: true,
            },
            {
              element: <ReasonForScanRoute />,
              path: 'reason-for-scan',
            },
            {
              element: <QualityReviewRoute />,
              path: 'quality-review',
            },
            {
              element: <AiFindingsRoute />,
              path: 'ai-findings',
            },
            {
              element: <OrganRoute />,
              path: 'organ/:organ',
            },
            {
              element: <KeyImagesRoute />,
              path: 'key-images',
            },
            {
              element: <FinalImpressionRoute />,
              path: 'final-impressions',
            },
            {
              element: <PreviewRoute />,
              path: 'preview',
            },
          ],
          element: <ReportingLayout />,
        },
      ],
      element: (
        <AuthGuard>
          <StudyGuard>
            <CarePlanServiceGuard>
              <Outlet />
            </CarePlanServiceGuard>
          </StudyGuard>
        </AuthGuard>
      ),
      errorElement: <ErrorBoundaryRoute />,
      path: '/reporting/:studyId',
    },
    {
      children: [
        {
          element: <CwfDocumentRoute />,
          path: 'cwf/:typeId',
        },
        {
          element: <MhsDocumentRoute />,
          path: 'mhs',
        },
        {
          element: <QualityReviewDocumentRoute />,
          path: 'quality-review/:itemId',
        },
        {
          element: <RadiologistReportDocumentRoute />,
          path: 'radiology-report',
        },
      ],
      element: (
        <AuthGuard>
          <Outlet />
        </AuthGuard>
      ),
      errorElement: <ErrorBoundaryRoute />,
      path: '/document/:studyId',
    },
    {
      children: [
        {
          element: <CwfDocumentRoute />,
          path: 'cwf/careplan/:carePlanId/:careActivityId/:typeId',
        },
      ],
      element: (
        <AuthGuard>
          <Outlet />
        </AuthGuard>
      ),
      errorElement: <ErrorBoundaryRoute />,
      path: '/document',
    },
    {
      element: <Navigate replace to="/404" />,
      path: '*',
    },
    {
      element: (
        <AuthGuard>
          <NotFoundRoute />
        </AuthGuard>
      ),
      errorElement: <ErrorBoundaryRoute />,
      path: '404',
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  },
);
